import React from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { AlertTriangle, ShieldOff } from 'react-feather';

const PageNotFound = () => {
  const isEmbedded = window.self !== window.top;

  return (
    <div className="d-flex align-items-center justify-content-center vh-100 bg-light">
      <Container>
        <Row className="justify-content-center text-center">
          <Col md="6" lg="5">
            <div className="bg-white p-5 rounded shadow-sm">
              <div className="mb-4">
                {isEmbedded ? (
                  <ShieldOff size={80} className="text-danger" />
                ) : (
                  <AlertTriangle size={80} className="text-warning" />
                )}
              </div>

              <h3 className="fw-semibold mb-3">
                {isEmbedded ? 'Unauthorized Access' : 'Page Not Found'}
              </h3>

              <p className="text-muted mb-4">
                {isEmbedded
                  ? 'This page cannot be accessed without proper authorization. Please ensure you are accessing the system through a valid session.'
                  : 'The page you are trying to access may have been moved, removed, or is temporarily unavailable.'}
              </p>

              {!isEmbedded && (
                <Button
                  color="primary"
                  size="lg"
                  className="px-5"
                  onClick={() => (window.location.href = '/')}>
                  Back to Dashboard
                </Button>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PageNotFound;
